import { render, staticRenderFns } from "./title-4.vue?vue&type=template&id=513c8260&scoped=true"
import script from "./title-4.vue?vue&type=script&lang=js"
export * from "./title-4.vue?vue&type=script&lang=js"
import style0 from "./title-4.vue?vue&type=style&index=0&id=513c8260&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513c8260",
  null
  
)

export default component.exports